import { isAgentUser } from 'ducks/chat/utils/users'

export const deliveryStateOptions = {
  checkIsSender: (_, mxEvent) => isAgentUser(mxEvent.getSender()),
}
